<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Новости
                </h3>
            </div>

<!--            <aside class="col-md-4">-->
<!--                <div class="p-4 mb-3 bg-light rounded">-->
<!--                    <ol class="list-unstyled mb-0">-->
<!--                        <li v-for="news in newsList" v-bind:key="news.id">-->
<!--                            <a :href="'#news' + news.id">-->
<!--                                {{news.title}}<br/>-->
<!--                                {{news.date}}-->
<!--                            </a>-->
<!--                        </li>-->
<!--                    </ol>-->
<!--                </div>-->
<!--            </aside>-->

            <div class="col-md-12 news-main">
                <div v-for="news in newsList" v-bind:key="news.id" class="news-post" :id="'news' + news.id">
                    <h2 class="news-post-title">{{news.title}}</h2>
                    <p class="news-post-meta">{{news.date}}</p>
                    <div v-html="news.text"></div>
                    <div class="text-center mb-3" v-if="news.imageLink != 0">
                        <img :src="'https://sale.katris.ru/uploads/images/saleKatrisNews/' + news.imageLink" style="max-width: 100%" />
                    </div>
                </div>

<!--                <nav class="news-pagination">-->
<!--                    <a class="btn btn-outline-primary mr-2" href="#" @click="older()"><i class="las la-angle-left"></i> Назад</a>-->
<!--                    <a v-if="pagination == 0" class="btn btn-outline-secondary disabled" disabled href="javascript:">Вперед <i class="las la-angle-right"></i></a>-->
<!--                    <a v-else class="btn btn-outline-primary" href="#" @click="newer()">Вперед <i class="las la-angle-right"></i></a>-->
<!--                </nav>-->
            </div>
        </div>

    </main>
</template>

<script>
    import rm_katris from "../js/rm_katris/app";

    export default {
        name: "New",
        metaInfo: {
            title: 'Новости',
            titleTemplate: '%s - sale.katris'
        },
        props: ['id'],
        data() {
            return {
                newsList: [],
            };
        },
        created() {
            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            let self = this;
            self.newsList = [];
            console.log(self.id)
            rm_katris.makePost('katrisSaleAdmin', 'getNews', {'token': this.$session.get('jwt'), 'id': self.id}, null, function(response) {
                console.log(response)
                if (response.status === 'OK') {
                    console.log(response.data)
                    response.data.text = response.data.text.replace('img src="/', 'img src="https://sale.katris.ru/');

                    let date =  new Date(response.data.date * 1000);
                    let month = date.getMonth() + 1;
                    let minutes = date.getMinutes();
                    if (minutes < 10) {
                        minutes = '0' + Number(minutes);
                    }
                    response.data.date = date.getDate() + '.' + (month < 10 ? '0' : '') + month + '.' + date.getFullYear() + ' ' + date.getHours() + ':' + minutes;

                    self.newsList.push(response.data);
                }
            });
        },
        methods: {

        },
    }
</script>

<style scoped>
    .news-header {
        line-height: 1;
        border-bottom: 1px solid #e5e5e5;
    }

    .display-4 {
        font-size: 2.5rem;
    }

    @media (min-width: 768px) {
        .display-4 {
            font-size: 3rem;
        }
    }

    .news-pagination {
        margin-bottom: 4rem;
    }

    .news-post {
        margin-bottom: 25px;
        padding-bottom: 25px;
        border-bottom: 1px solid #dee2e6
    }

    .news-post-title {
        margin-bottom: .25rem;
        font-size: 2.5rem;
    }

    .news-post-meta {
        margin-bottom: 1.25rem;
        color: #999;
    }

    .ql-video {
        width: 100%;
        height: 411px;
    }
</style>
